







































































































































































































































































































































import { ItemDaTabelaDePreco, Produto, Variante } from '@/models'
import { ImportacaoDeNota, ProdutoDaImportacao, VariantesDaImportacao } from '@/models/ImportacaoDeNota'
import { formatarMoeda } from '@/shareds/formatadores'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import { FinalizarImportacaoDeNotaDoFornecedorUseCase, FindProdutoUseCase, SaveProdutoUseCase } from '@/usecases'
import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import DialogoDeBuscarVinculoDeProdutos from './DialogoDeBuscarVinculoDeProdutos.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import * as LZString from 'lz-string'

const IMPORTACAO_DE_NOTA = 'IMPORTACAO_DE_NOTA'

@Component({
	components: {
		DialogoDeBuscarVinculoDeProdutos,
		Confirmacao,
	},
})
export default class DialogoDeRelacaoDeVariantesParaEntradaDaNota extends Vue {
	@Prop({ type: String, default: 'id' }) itemKey!: string
	@Prop({ type: Array, default: () => [] }) itensExistentes!: Produto[]
	@Ref() dialogoDeBuscarVinculoDeProdutos!: DialogoDeBuscarVinculoDeProdutos
	@Ref() confirmarCriacaoDeProdutos!: Confirmacao

	finalizarImportacaoDeNotaDoFornecedorUseCase = new FinalizarImportacaoDeNotaDoFornecedorUseCase
	saveProdutoUseCase = new SaveProdutoUseCase()
	findProdutoUseCase = new FindProdutoUseCase()

	mostrar = false
	filtro = ''
	selecionados: VariantesDaImportacao[] = []
	expanded: any[] = []
	produtos: VariantesDaImportacao[] = []
	opcoes: Produto[] = []
	produtosParaVincular: Produto[] = []
	relacionamentos: any[] = []
	importacaoDeNota: ImportacaoDeNota | null = (() => {
		try {
			const raw = localStorage.getItem(IMPORTACAO_DE_NOTA)
			if (!raw) return null
			const json = LZString.decompress(raw) ?? raw
			return JSON.parse(json)
		} catch {
			return null
		}
	})()
	formatarMoeda = formatarMoeda
	produtosIntegrosDaNota: VariantesDaImportacao[] = []
	vinculosProdutos: Record<number, string> = {};
	mostrarDialogoDeCriarProdutoPai = false
	nomeDoNovoProdutoPai = ''
	codDoNovoProdutoPai = ''
	carregandoCriacaoDeItemPai = false
	variantesDaImportacao: Variante[] = []
	tipoDoFiltro = 'nomeDoProduto'

	get headers () {
		return [
			{ text: 'Produto', value: 'produto', align: 'start' , sortable: false},
			{ text: 'Ações', value: 'actions', align: 'center' , sortable: false},
		]
	}

	get headerVarianteAberta () {
		return [
			{ text: 'Produto', value: 'produto', align: 'start', sortable: false },
			{ text: 'Quantidade', value: 'nota.qCom', align: 'start', sortable: false },
			{ text: 'NCM', value: 'nota.NCM', align: 'start', sortable: false },
			{ text: 'Valor Unitario', value: 'nota.vProd', align: 'start', sortable: false },
			{ text: 'Ações', value: 'actions', align: 'center', sortable: false },
		]
	}

	get headerVarianteAbertaSemCriacaoDeProduto () {
		return [
			{ text: 'Produto', value: 'nota.xProd', align: 'start', sortable: false },
			{ text: 'Quantidade', value: 'nota.qCom', align: 'start', sortable: false },
			{ text: 'NCM', value: 'nota.NCM', align: 'start', sortable: false },
			{ text: 'Valor Unitario', value: 'nota.vProd', align: 'start', sortable: false },
		]
	}

	get headersItens () {
		return [
			{ text: 'Item', value: 'nome', align: 'start' },
			{ text: 'Relacionamento', value: 'acao', sortable: false },
			{ text: 'Referência pai', value: 'referenciaPai', sortable: false },
			{ text: 'Item existente', value: 'itemExistente', sortable: false },
		]
	}

	get opcoesDeRelacionamento () {
		return [
			{ text: 'Sem relacionamento', value: 'nenhum' },
			{ text: 'Usar referência pai', value: 'referencia' },
			{ text: 'Apontar item existente', value: 'existente' },
		]
	}

	getItemId (item: any): string | number {
		return item?.[this.itemKey]
	}

	mounted() {
		this.inicializarRelacionamentos()
	}

	@Watch('produtos', { immediate: true })
	onProdutosAlterados() {
		this.$nextTick(() => {
			this.inicializarRelacionamentos()
		})
	}

	@Watch('mostrar')
	onMostrarChanged(newValue: boolean) {
		if (newValue) {
			this.$nextTick(() => {
				this.inicializarRelacionamentos()
			})
		} else {
			this.selecionados = []
			this.expanded = []
			this.filtro = ''
		}
	}

	inicializarRelacionamentos() {
		if (!this.produtos || this.produtos.length === 0) {
			return
		}

		this.produtos.forEach(p => {
			const id = this.getItemId(p)
			if (id != null && this.relacionamentos[id] == null) {
				this.$set(this.relacionamentos, id, { modo: 'nenhum' })
			}
		})
	}

	mostrarDialogo(importacaoDeNota?: ImportacaoDeNota){
		if (!importacaoDeNota) return
		this.importacaoDeNota = importacaoDeNota

		importacaoDeNota.produtos.forEach(p => {
			p.encontrado && p.encontrado.id !== null ?
				p.contemVinculoAutomatico = true :
				p.contemVinculoAutomatico = false

			if(p.encontrado && p.encontrado.id)	{
				this.produtosParaVincular = [
					...this.produtosParaVincular,
					p.encontrado,
				].filter(
					(p, index, self) => index === self.findIndex(prod => prod.sku === p.sku),
				);
			}
		})

		this.mostrar = true
		this.importacaoDeNota = importacaoDeNota
		this.produtos = importacaoDeNota.produtos.map((p: ProdutoDaImportacao) => ({
			produtoPai: p.encontrado,
			nota: p.nota,
			indice: p.indice,
			margemDeLucro: p.margemDeLucro,
			precoFinalVarejo: p.precoFinalVarejo,
			quantidadeInformada: p.quantidadeInformada,
			isProdutoPossuiNomeLongo: p.isProdutoPossuiNomeLongo,
			isPossuiCProdDuplicado: p.isPossuiCProdDuplicado,
			erroNomeDeProdutoEhLongo: p.erroNomeDeProdutoEhLongo,
			erroReferenciaDeProduto: p.erroReferenciaDeProduto,
			contemVinculoAutomatico: p.contemVinculoAutomatico,
			isProdutoComReferenciaCriadaNaImportacao: p.isProdutoComReferenciaCriadaNaImportacao,
			itemKey: p.nota.nItem,
			isProdutoEstaAgrupado: p.isProdutoEstaAgrupado,
			tipoDaOrigemDoProduto: p.tipoDaOrigemDoProduto,
			codigoOrigemDoProduto: p.codigoOrigemDoProduto,
		}));

		this.produtosIntegrosDaNota = this.produtos
		this.inicializarRelacionamentos()
	}

	esconderDialogo(){
		this.mostrar = false
	}

	onCancelar(){
		this.esconderDialogo()
		this.resetarDialogo()
		this.$emit('cancelar')
	}

	async confirmar(){
		if(!this.importacaoDeNota) return

		this.importacaoDeNota.produtos = []
		this.variantesDaImportacao = []

		const possuiProdutosSemPai = this.produtos.some(
			p => !p.produtoPai?.id && !p.isProdutoComReferenciaCriadaNaImportacao,
		);

		if(possuiProdutosSemPai){
			AlertModule.setError('Existem produtos sem vínculo com o produto pai. Por favor, vincule todos os produtos antes de confirmar.')
			return
		}

		const produtosComReferenciaCriandaNaImportacao = this.produtos.filter(
			p => p.isProdutoComReferenciaCriadaNaImportacao && p.produtoPai && !p.produtoPai.id,
		);

		const isNecessarioConfirmarProcesso = produtosComReferenciaCriandaNaImportacao.length > 0 ? await this.confirmarCriacaoDeProdutos.mostrar() : null

		if(isNecessarioConfirmarProcesso){
			const skusJaProcessados = new Set<string>();
			const produtosPaiCriados = new Map<string, any>();
			
			for (const produto of produtosComReferenciaCriandaNaImportacao) {
				if(!produto.produtoPai) return
				if (!produto.produtoPai.sku) return;

				if (!skusJaProcessados.has(produto.produtoPai.sku)) {
					skusJaProcessados.add(produto.produtoPai.sku);

					try{
						this.carregandoCriacaoDeItemPai = true;
						// eslint-disable-next-line no-await-in-loop
						produto.produtoPai.id = await this.saveProdutoUseCase.createProdutoNaImportacao(produto.produtoPai);
						if(produto.produtoPai.tipo === 'Com Variantes'){
							produto.produtoPai.produtoIncompleto = true
						}
					
						produtosPaiCriados.set(produto.produtoPai.sku, produto.produtoPai);
					} catch(e) {
						AlertModule.setError(e)
						this.carregandoCriacaoDeItemPai = false
						return
					} finally {
						this.carregandoCriacaoDeItemPai = false
					}
				}
			}

			this.produtos = this.produtos.map(produto => {
				
				if (produto.isProdutoComReferenciaCriadaNaImportacao && produto.produtoPai) {

					const produtoAtualizado = produtosPaiCriados.get(produto.produtoPai.sku != null ? produto.produtoPai.sku : '');
					if (produtoAtualizado) {
						return {
							...produto,
							produtoPai: produtoAtualizado,
						};
					}
				}
				return produto;
			});
		}else if(!isNecessarioConfirmarProcesso && isNecessarioConfirmarProcesso !== null){
			AlertModule.setWarning('Processo De Criação Foi Cancelado!')
			return
		}

		this.produtos.forEach(variante => {
			let produtoPaiEncontrado = this.importacaoDeNota?.produtos.find(
				p => (p.encontrado?.sku === variante.produtoPai?.sku),
			);

			const totalComprado = this.produtos
				.filter(p => p.produtoPai?.sku === variante.produtoPai?.sku)
				.map(p => Number(p.nota.qCom) || 0)
				.reduce((soma, valor) => soma + valor, 0);

			if (!produtoPaiEncontrado) {
				produtoPaiEncontrado = {
					encontrado: variante.produtoPai,
					nota: { 
						cProd: variante.produtoPai?.sku || variante.nota.cProd,
						xProd: variante.produtoPai?.nome || variante.nota.xProd,
						cEAN: variante.nota.cEAN,
						NCM: variante.nota.NCM,
						qCom: totalComprado.toString(),
						uCom: variante.nota.uCom,
						vUnCom: variante.nota.vUnCom,
						vProd: variante.nota.vProd,
						nItem: variante.nota.nItem,
					},
					item: {} as any as ItemDaTabelaDePreco,
					margemDeLucro: 0,
					precoFinalVarejo: 0,
					quantidadeInformada: variante.quantidadeInformada,
					isProdutoComReferenciaCriadaNaImportacao: variante.isProdutoComReferenciaCriadaNaImportacao,
					isProdutoPossuiNomeLongo: variante.isProdutoPossuiNomeLongo,
					isPossuiCProdDuplicado: variante.isPossuiCProdDuplicado,
					erroNomeDeProdutoEhLongo: variante.erroNomeDeProdutoEhLongo,
					erroReferenciaDeProduto: variante.erroReferenciaDeProduto,
					contemVinculoAutomatico: variante.contemVinculoAutomatico,
					indice: variante.indice,
					isCamposBloqueados: false,
					isNomeECodigoConfirmados: false,
					criouRelacaoDeProdutoPai: false,
					contemAgrupamentoDeItens: false,
					produtosAgrupados: [] as ProdutoDaImportacao[],
					itemKey: variante.nota.nItem,
					isProdutoEstaAgrupado: false,
					tipoDaOrigemDoProduto: variante.tipoDaOrigemDoProduto,
					codigoOrigemDoProduto: variante.codigoOrigemDoProduto,
				};
				
				this.importacaoDeNota?.produtos.push(produtoPaiEncontrado);
			}

			if (produtoPaiEncontrado?.encontrado?.tipo === 'Com Variantes') {
				const novaVariante: Variante = {
					id: '',
					tipo: 'Variante',
					nome: variante.nota.xProd,
					sku: variante.nota.cProd,
					idProdutoPai: variante.produtoPai?.id,
					atributosVariante: [],
					descricao: 'Produto Criado na Importação',
					tags: [],
					skuPai: variante.produtoPai?.sku || null,
					eans: [
						variante.nota.cEAN,
					],
					marca: variante.produtoPai?.marca || null,
					categoria: variante.produtoPai?.categoria || null,
					ncm: {
						codigo: variante.nota.NCM,
						descricao: '',
					},
					cest: variante.produtoPai?.cest || null,
					urlImagens: [],
					preco: variante.produtoPai?.preco || null,
					pesoLiquido: variante.produtoPai?.pesoLiquido || null,
					pesoBruto: variante.produtoPai?.pesoBruto || null,
					regrasFiscais: [],
					temGarantia: variante.produtoPai?.temGarantia || false,
					unidadeDeMedida: variante.produtoPai?.unidadeDeMedida || '',
					identificadores: [],
					nomeCompleto: '',
					produtoDesativado: variante.produtoPai?.produtoDesativado || false,
					produtoIntegrado: variante.produtoPai?.produtoIntegrado || false,
					descontoVarejo: variante.produtoPai?.descontoVarejo || null,
					genero: variante.produtoPai?.genero || null,
					fatorDeConversao: variante.produtoPai?.fatorDeConversao || null,
					unidadeDeConversao: variante.produtoPai?.unidadeDeConversao || null,
					estacao: variante.produtoPai?.estacao || null,
					isValePresente: variante.produtoPai?.isValePresente || false,
					quantidadeImportacao: Number(variante.nota.qCom) || null,
					fornecedor: variante.produtoPai?.fornecedor || null,
					precoCompra: variante.produtoPai?.precoCompra || null,
					margemLucro: variante.produtoPai?.margemLucro || null,
					varianteVinculada: null,
					vinculada: false,
					produtoIncompleto: false,
					familiasDoProduto: variante.produtoPai?.familiasDoProduto || [],
					tipoDaOrigemDoProduto: variante.tipoDaOrigemDoProduto,
					codigoOrigemDoProduto: variante.codigoOrigemDoProduto,
				};

				this.variantesDaImportacao.push(novaVariante)
			}
		});

		this.$emit('confirmar', this.importacaoDeNota.produtos, this.variantesDaImportacao)
		this.resetarDialogo()
		this.esconderDialogo()
		this.carregandoCriacaoDeItemPai = false
	}

	resetarDialogo(){
		this.selecionados = []
		this.expanded = []
		this.filtro = ''
		this.produtos = []
		this.opcoes = []
		this.relacionamentos = []
		this.produtosParaVincular = []
		this.produtosIntegrosDaNota = []
		this.vinculosProdutos = {}
	}

	get produtosPendentesDeVerificacao(){
		return this.produtos.filter(p => !p.produtoPai?.id && !p.isProdutoComReferenciaCriadaNaImportacao).length
	}

	get produtosVerificados(){
		return this.produtos.filter(p => p.produtoPai?.id || p.isProdutoComReferenciaCriadaNaImportacao).length
	}

	async vincularProdutoPai() {
		if(!this.importacaoDeNota) return
		
		if (this.selecionados.length === 0) {
			AlertModule.setError('Necessário selecionar uma variante para vincular ao pai!');
			return;
		}

		const nomes = this.selecionados.map(item => item.nota.xProd);
		const palavrasPorNome = nomes.map(n => n.trim().split(/\s+/));
		const nomeCompleto = palavrasPorNome.reduce((acc, palavras) => {
			return acc.filter(p => palavras.includes(p));
		});

		this.dialogoDeBuscarVinculoDeProdutos.mostrar(0, nomeCompleto.join(" "), this.podeCriarProduto);
	}

	onProdutoParaRelacao(produtoPai: Produto[]){
		const ncmBase = this.produtos.find(p => p.produtoPai?.sku === produtoPai[0].sku)?.nota.NCM || this.selecionados[0].nota.NCM;
		const todasIguais = this.selecionados.every(v => v.nota.NCM === ncmBase);

		if (!todasIguais) {
			AlertModule.setError('Não é possível agrupar variantes com NCMs diferentes');
			return;
		}

		this.selecionados.forEach(item => {
			item.produtoPai = produtoPai[0];
			item.isProdutoComReferenciaCriadaNaImportacao = true

			if (item.produtoPai) {
				this.produtosParaVincular = [
					...this.produtosParaVincular,
					item.produtoPai,
				].filter(
					(p, index, self) => index === self.findIndex(prod => prod.sku === p.sku),
				);
			}

			this.produtos.filter(p => p.nota.xProd === item.nota.xProd).forEach(p => {
				p.produtoPai = produtoPai[0];
			});
		});
		
		AlertModule.setSuccess(`Produto pai vinculado a ${this.selecionados.length} grupo(s) com sucesso!`);
		
		this.selecionados = []
	}

	get permiteFinalizar(){
		return this.produtos.filter(p => p.produtoPai && (p.produtoPai.id || p.isProdutoComReferenciaCriadaNaImportacao)).length > 0
	}

	getVariantesRelacionadas(produto: Produto) {
		if (!this.produtos || !produto) return []
		
		return this.produtos
			.filter(p => p.produtoPai?.sku === produto.sku)
	}

	desvincularProdutoPai(item: Produto) {
		this.produtos.filter(p => p.produtoPai?.sku === item.sku).forEach(p => {
			if(p.produtoPai){
				this.vinculosProdutos[p.indice] = p.produtoPai.id;
				p.produtoPai.id = '';
				p.produtoPai = {} as Produto
				p.isProdutoComReferenciaCriadaNaImportacao = false
			}
		});

		this.produtosParaVincular = this.produtosParaVincular.filter(p => p.sku !== item.sku)
	}

	vincularVariantesNoProdutoPai(item: Produto){
		const ncmBase = this.produtos.find(p => p.produtoPai?.sku === item.sku)?.nota.NCM || this.selecionados[0].nota.NCM;
		const todasIguais = this.selecionados.every(v => v.nota.NCM === ncmBase);

		if (!todasIguais) {
			AlertModule.setError('Não é possível agrupar variantes com NCMs diferentes');
			return;
		}

		this.selecionados.forEach(variante => {
			variante.produtoPai = item;
			variante.isProdutoComReferenciaCriadaNaImportacao = true

			if (variante.produtoPai) {
				this.produtosParaVincular = [
					...this.produtosParaVincular,
					variante.produtoPai,
				].filter(
					(p, index, self) => index === self.findIndex(prod => prod.sku === p.sku),
				);
			}

			this.produtos.filter(p => p.nota.xProd === variante.nota.xProd).forEach(p => {
				p.produtoPai = item;
			});
		});

		AlertModule.setSuccess(`Produto pai vinculado a ${this.selecionados.length} variante(s) com sucesso!`);

		this.selecionados = []
	}

	removerVinculoDoItemPai(item){
		this.produtosParaVincular = this.produtosParaVincular.filter(p => p.sku !== item.produtoPai.sku)

		this.produtos.filter(p => p.indice === item.indice).forEach(p => {
			p.produtoPai = [] as any as Produto;
			p.isProdutoComReferenciaCriadaNaImportacao = false
		});
	}

	get modoNoturno(){
		return AppStore.modoNoturno
	}

	listarCores(produto: Produto) {
		if (!produto) return []
		if (produto.tipo === 'Com Variantes' && Array.isArray((produto as any).variantes)) {
			const cores = (produto as any).variantes
				.map(v => this.obterValorDoAtributo(v, 'Cor'))
				.filter(v => !!v)
			return Array.from(new Set(cores))
		}
		return []
	}

	listarGrades(produto: Produto) {
		if (!produto) return []
		if (produto.tipo === 'Com Variantes' && Array.isArray((produto as any).variantes)) {
			const tamanhos = (produto as any).variantes
				.map(v => this.obterValorDoAtributo(v, 'Tamanho'))
				.filter(v => !!v)
			return Array.from(new Set(tamanhos))
		}
		return []
	}

	obterValorDoAtributo(variante, atributoEsperado) {
		const valorFiltrado =  variante.atributosVariante.filter(atributo => atributo.nome.toUpperCase() === atributoEsperado.toUpperCase())

		if (valorFiltrado.length > 0) {
			return valorFiltrado[0].valor
		}
		return 'Sem '+atributoEsperado
	}

	abrirDialogoDeCriarProdutoPai(){
		const nomes = this.selecionados.map(item => item.nota.xProd);
		const palavrasPorNome = nomes.map(n => n.trim().split(/\s+/));
		const intersecao = palavrasPorNome.reduce((acc, palavras) => {
			return acc.filter(p => palavras.includes(p));
		});

		const codigo = this.selecionados.map(item => item.nota.cProd);
		const codigosIguais = codigo.map(n => n.trim().split(/\s+/));
		const intersecaoCod = codigosIguais.reduce((acc, codigos) => {
			return acc.filter(p => codigos.includes(p));
		});

		this.nomeDoNovoProdutoPai = intersecao.join(" ");
		this.codDoNovoProdutoPai = intersecaoCod.join(" ");
		if(this.codDoNovoProdutoPai === '' || this.codDoNovoProdutoPai === null){
			this.gerarCodProdutoPai()
		}
		this.mostrarDialogoDeCriarProdutoPai = true
	}

	gerarCodProdutoPai(){
		this.codDoNovoProdutoPai = '9' + Date.now().toString().substring(1);
	}

	async criarProdutoPai(){
		const novoProdutoPai = {
			nome: this.nomeDoNovoProdutoPai?.trim(),
			sku: this.codDoNovoProdutoPai?.trim(),
			tipo: 'Com Variantes',
			produtoDesativado: false,
			eans: [this.codDoNovoProdutoPai?.trim()],
			descricao: 'Produto Criado na Importação',
			temGarantia: false,
			ncm: {
				codigo: this.selecionados[0].nota.NCM,
				descricao: '',
			},
			precoCompra: this.selecionados[0].produtoPai?.precoCompra,
			unidadeDeMedida: this.selecionados[0].produtoPai?.unidadeDeMedida,
			unidadeDeConversao: this.selecionados[0].produtoPai?.unidadeDeConversao,
		} as unknown as Produto;

		let produtoJaExiste: Produto | null = null

		try {
			produtoJaExiste = await this.findProdutoUseCase
				.findProdutoPorIdentificador(this.codDoNovoProdutoPai)
		} catch (error: any) {
			if (error?.response?.status !== 404) {
				throw error
			}
		}

		if (produtoJaExiste) {
			AlertModule.setError('Já existe um produto com o código SKU gerado.')
			return
		}

		const ncmBase = this.selecionados[0].nota.NCM;
		const todasIguais = this.selecionados.every(v => v.nota.NCM === ncmBase);

		if (!todasIguais) {
			AlertModule.setError('Não é possível agrupar variantes com NCMs diferentes');
			return;
		}

		this.produtosParaVincular = [
			...this.produtosParaVincular,
			novoProdutoPai,
		].filter(
			(p, index, self) => index === self.findIndex(prod => prod.sku === p.sku),
		);

		this.nomeDoNovoProdutoPai = ''
		this.codDoNovoProdutoPai = ''
		this.vincularVariantesNoProdutoPai(novoProdutoPai)
		this.mostrarDialogoDeCriarProdutoPai = false
	}

	formatarMensagemDaCriacaoDeProdutos(){
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Se confirmar, serão criados produtos pai
				</div>
			`
	}

	get podeCriarProduto(){
		return this.importacaoDeNota?.lojaDestinoDaImportacao
			?.configuracaoDaLoja?.criarProdutoImportacaoEntrada ?? false
	}

	produtosProcessados() {
		return this.produtos.map(produto => ({
			...produto,
			itemKey: produto.nota?.nItem,
		}));
	}

	handleSelecionarTodos(props) {
		const produtosSelecionaveis = this.produtos.filter(
			p => !p.produtoPai?.id && !p.isProdutoComReferenciaCriadaNaImportacao,
		);

		if (props.value) {
			this.selecionados = produtosSelecionaveis;
		} else {
			this.selecionados = [];
		}
	}
}
